import { Redirect } from 'react-router-dom';
import { useIsTrialActive } from '../../hooks/use-is-trial-active';
import { HOME_PAGE_PATH } from '../../routes/constants';
import { ChildrenPropType } from '../../prop-types/children';

/**
 * Route protection component that requires an active trial to access child components
 * Redirects to home page if trial is expired or inactive
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render when trial is active
 * @returns {React.ReactNode} Child components if trial is active, redirect otherwise
 */
export const TrialRequired = ({ children }) => {
  const isTrialActive = useIsTrialActive();

  return isTrialActive ? children : <Redirect to={HOME_PAGE_PATH} />;
};

TrialRequired.propTypes = {
  children: ChildrenPropType.isRequired,
};
